import React from 'react';
import { Facebook, Twitter, Smartphone, Copy } from 'lucide-react';

export default function MockupArcade() {
  return (
    <div className="min-h-screen bg-[#050510] text-[#00FFFF] relative overflow-hidden selection:bg-[#FF00FF] selection:text-white pb-20" style={{fontFamily: "'Orbitron', sans-serif"}}>
      {/* Scanlines overlay */}
      <div className="pointer-events-none fixed inset-0 z-50 opacity-15" style={{backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgba(0, 255, 255, 0.15) 50%)', backgroundSize: '100% 4px'}}></div>
      {/* Glow overlay */}
      <div className="pointer-events-none fixed inset-0 z-0 bg-[radial-gradient(circle_at_center,rgba(46,108,46,0.15)_0%,rgba(0,0,0,0)_70%)]"></div>

      {/* Ticker */}
      <div className="bg-[#2e6c2e] text-black font-black uppercase text-xs py-1 px-4 overflow-hidden shadow-[0_0_15px_#2e6c2e] relative z-20">
         <div className="animate-marquee whitespace-nowrap tracking-widest font-mono">
           [ SYSTEM LOG ] KTOŚ ZAGŁOSOWAŁ NA GDAŃSK · 36S TEMU // [ SYSTEM LOG ] KTOŚ ZAGŁOSOWAŁ NA KRAKÓW · 1M TEMU // [ SYSTEM LOG ] KTOŚ ZAGŁOSOWAŁ NA WARSZAWA · 2M TEMU // 
         </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-16 relative z-10 flex flex-col items-center">
         <img src="https://customer-assets.emergentagent.com/job_skate-tour-1/artifacts/ahdsblol_LOGO%20SCOOTIVE.svg" className="h-10 md:h-14 w-auto mb-10 filter brightness-0 invert drop-shadow-[0_0_10px_rgba(255,255,255,0.8)]" alt="Scootive" />
         
         <h1 className="text-5xl md:text-7xl lg:text-8xl font-black italic text-center mb-2 tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white via-[#C0C0C0] to-gray-600 drop-shadow-[0_4px_0_rgba(46,108,46,1)]">
            SCOOTIVE TOUR
         </h1>
         <div className="text-2xl md:text-4xl font-bold text-[#2e6c2e] drop-shadow-[0_0_15px_#2e6c2e] mb-12 tracking-widest bg-black/50 px-6 py-2 border border-[#2e6c2e]/50 rounded-full">
            &gt; SIERPIEŃ 2026_
         </div>

         <div className="flex gap-4 md:gap-8 mb-16 text-center" data-testid="countdown-timer">
            {[ {v: '14', l: 'DNI'}, {v: '08', l: 'GODZ'}, {v: '45', l: 'MIN'}, {v: '12', l: 'SEK'} ].map((t,i) => (
               <div key={i} className="bg-black/60 border-2 border-[#00FFFF] backdrop-blur-sm p-4 min-w-[80px] md:min-w-[100px] -skew-x-12 shadow-[0_0_15px_rgba(0,255,255,0.4)] hover:shadow-[0_0_25px_rgba(0,255,255,0.8)] transition-shadow">
                  <div className="text-3xl md:text-5xl font-black mb-1 text-white drop-shadow-[0_0_8px_#00FFFF]">{t.v}</div>
                  <div className="text-[10px] md:text-xs text-[#00FFFF] tracking-widest">{t.l}</div>
               </div>
            ))}
         </div>

         {/* Vote Interface */}
         <div className="w-full max-w-2xl bg-[#0a0a2a]/80 backdrop-blur-md border-2 border-[#2e6c2e] p-8 md:p-12 relative shadow-[0_0_40px_rgba(46,108,46,0.3)] rounded-xl">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#2e6c2e] text-black px-8 py-2 font-bold rounded-full text-sm md:text-base shadow-[0_0_15px_#2e6c2e] whitespace-nowrap tracking-widest font-mono">
               PLAYER 1: SELECT STAGE
            </div>
            
            <div className="mt-8 mb-10 grid grid-cols-1 md:grid-cols-2 gap-4">
               {['GDAŃSK', 'WARSZAWA', 'KRAKÓW', 'POZNAŃ'].map((city, i) => (
                  <label key={i} className="cursor-pointer group relative block">
                     <input data-testid="vote-city-radio" type="radio" name="city" className="peer sr-only" defaultChecked={i===0} />
                     <div className="px-4 py-4 border-2 border-[#00FFFF]/30 text-center peer-checked:border-[#2e6c2e] peer-checked:bg-[#2e6c2e]/20 peer-checked:text-white transition-all peer-checked:shadow-[inset_0_0_20px_rgba(46,108,46,0.6),0_0_15px_rgba(46,108,46,0.4)] hover:border-[#00FFFF] hover:shadow-[0_0_15px_rgba(0,255,255,0.3)] bg-black/40 skew-x-[-5deg]">
                        <span className="skew-x-[5deg] block font-bold tracking-widest">{city}</span>
                     </div>
                  </label>
               ))}
            </div>

            <button data-testid="vote-submit-button" className="w-full bg-gradient-to-r from-[#2e6c2e] to-[#45a045] text-black font-black text-2xl py-5 hover:scale-[1.02] active:scale-[0.98] transition-transform shadow-[0_0_25px_#2e6c2e] relative overflow-hidden group border-2 border-[#98FF98]">
               <div className="absolute inset-0 bg-white/30 -translate-x-full group-hover:translate-x-full transition-transform duration-500 ease-in-out skew-x-12"></div>
               PRESS START TO VOTE
            </button>

            <div className="flex justify-center gap-8 mt-10">
               <Facebook data-testid="share-facebook" size={24} className="text-[#00FFFF] hover:text-white hover:drop-shadow-[0_0_10px_#00FFFF] cursor-pointer transition-all hover:-translate-y-1" />
               <Twitter data-testid="share-twitter" size={24} className="text-[#00FFFF] hover:text-white hover:drop-shadow-[0_0_10px_#00FFFF] cursor-pointer transition-all hover:-translate-y-1" />
               <Smartphone data-testid="share-whatsapp" size={24} className="text-[#00FFFF] hover:text-white hover:drop-shadow-[0_0_10px_#00FFFF] cursor-pointer transition-all hover:-translate-y-1" />
               <Copy data-testid="share-copy" size={24} className="text-[#00FFFF] hover:text-white hover:drop-shadow-[0_0_10px_#00FFFF] cursor-pointer transition-all hover:-translate-y-1" />
            </div>
         </div>

         {/* Rankings */}
         <div className="w-full max-w-3xl mt-24">
            <h3 className="text-2xl text-[#00FFFF] mb-8 text-center drop-shadow-[0_0_8px_#00FFFF] font-black tracking-widest">HIGH SCORES</h3>
            <div className="bg-black/80 border-2 border-[#00FFFF]/30 p-8 rounded-xl shadow-[0_0_20px_rgba(0,255,255,0.1)]">
               {[{n: "GDAŃSK", p: 85}, {n: "WARSZAWA", p: 60}, {n: "KRAKÓW", p: 45}].map((c,i) => (
                  <div key={i} className="flex items-center gap-4 md:gap-6 mb-6 last:mb-0 text-sm md:text-lg">
                     <div className="text-[#00FFFF]/70 w-8 font-mono">{i+1}.</div>
                     <div className="w-32 md:w-40 truncate text-white font-bold tracking-widest">{c.n}</div>
                     <div className="flex-1 h-4 bg-gray-900 border border-[#00FFFF]/20 rounded-full overflow-hidden shadow-[inset_0_0_10px_rgba(0,0,0,1)]">
                        <div className="h-full bg-gradient-to-r from-[#2e6c2e] to-[#00FFFF] relative" style={{width: `${c.p}%`}}>
                           <div className="absolute inset-0 opacity-50 bg-[repeating-linear-gradient(45deg,transparent,transparent_5px,rgba(255,255,255,0.2)_5px,rgba(255,255,255,0.2)_10px)]"></div>
                        </div>
                     </div>
                     <div className="text-[#00FFFF] w-16 text-right font-mono drop-shadow-[0_0_5px_#00FFFF]">{c.p}%</div>
                  </div>
               ))}
            </div>
         </div>
      </div>
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes marquee { 0% { transform: translateX(100%); } 100% { transform: translateX(-100%); } }
        .animate-marquee { display: inline-block; animation: marquee 25s linear infinite; }
      `}} />
    </div>
  );
}
